import React, { useState } from 'react';
import {
    SimpleForm, TextInput, SelectInput, Edit, Toolbar,
    NumberInput, required, useTranslate, usePermissions, useRecordContext
} from 'react-admin';
import {
    Statuses_5_Approvatore,
    Anomalie_Approvatore_To_DaEsaminare, Anomalie_Approvatore_Attribuito_To_Chiuso, Anomalie_Approvatore_Attribuito_MOS_To_Chiuso,
    Anomalie_Approvatore_DaEsaminare_To_Chiuso, Statuses_6_Approvatore, Statuses_7_Approvatore
} from '../objects';
import ValidateAndSaveButton from '../devices/Buttons/ValidateAndSave';
import { useFormState, useForm } from 'react-hook-form';
import { Typography, Box, Card, Grid } from '@mui/material';

function DeviceDaEsaminareEdit() {

    const [new_status, set_new_status] = useState(undefined);
    const [new_anomalia, set_new_anomalia] = useState(undefined);
    const [new_num_consegna, set_new_num_consegna] = useState(undefined);
    const [new_cod_terr_sap, set_new_cod_terr_sap] = useState(undefined);

    const translate = useTranslate();
    const permissions = usePermissions().permissions;
    const methods = useForm();
    const { isPristine } = useFormState(methods);

    const onChange = (caller) => {
        if (caller.target.name === 'status.codice') {
            set_new_status(caller.target.value);
        }
        if (caller.target.name === 'anomalia.codice') {
            set_new_anomalia(caller.target.value);
        }
        if (caller.target.name === 'num_consegna') {
            set_new_num_consegna(caller.target.value);
        }
        if (caller.target.name === 'cod_terr_sap') {
            set_new_cod_terr_sap(caller.target.value);
        }
    };

    const validateNumConsegna = (value, allValues) => {
        if (value && (isNaN(value) || value.toString().length !== 10)) {
            return translate('tim.devices.isvalid_num_consegna');
        }
        else return undefined;
    }

    const requiredNumConsegna = [required(), validateNumConsegna];

    const validateNote = (value, allValues) => {
        if (value) {
            let format = /[^a-zA-Z0-9 ]/g;
            if (format.test(value)) return translate('tim.devices.invalid_note');
        }
        return undefined;
    }

    const DeviceTitle = () => {
        const record = useRecordContext();
        if (!record) return null;
        return <span>Apparato {record ? `${record.serial_number_tim}` : ''}</span>;
    };


    const DeviceToolbar = () => {
        const record = useRecordContext();
        if (!record) return null;
        let disable = true;

        if (record.status) {
            let originalStatus = record.status.codice;

            if (!new_status) {
                set_new_status(originalStatus);
            }

            if (!isPristine) {
                if (permissions === "approvatore") {
                    if (new_status === '9' && ['0','1', '6'].includes(originalStatus)) {
                        disable = false;
                    }
                }
            }
        }

        if (record.num_consegna && new_num_consegna) {
            const original = record.num_consegna;
            const newValue = new_num_consegna;

            if (!isPristine &&
                permissions === "approvatore" &&
                newValue !== original) {
                disable = false;
            }
        }

        if (record.cod_terr_sap && new_cod_terr_sap) {
            const original = record.cod_terr_sap;
            const newValue = new_cod_terr_sap;

            if (!isPristine &&
                permissions === "approvatore" &&
                newValue !== original) {
                disable = false;
            }
        }

        return <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }} >
            <ValidateAndSaveButton
                disabled={disable}
                label="Salva"
                redirect="list"
                submitOnEnter={false}
                variant="flat"
            />
        </Toolbar>
    };

    const Status = () => {
        const record = useRecordContext();
        if (!record) return null;

        if (permissions === "approvatore" && record.status && ['0'].includes(record.status.codice)) {
            return <SelectInput source="status.codice" label='Stato' choices={Statuses_5_Approvatore} onChange={onChange} validate={required()} />
        }
        else if (permissions === "approvatore" && record.status && ['1'].includes(record.status.codice)) {
            return <SelectInput source="status.codice" label='Stato' choices={Statuses_6_Approvatore} onChange={onChange} validate={required()} />
        }
        else if (permissions === "approvatore" && record.status && ['6'].includes(record.status.codice)) {
            return <SelectInput source="status.codice" label='Stato' choices={Statuses_7_Approvatore} onChange={onChange} validate={required()} />
        }
        else {
            return <TextInput source="status.codice" disabled />
        }
    }

    const Anomalia = () => {
        const record = useRecordContext();
        if (!record) return null;

        if (permissions === "approvatore" && new_status === '0' && record.status.codice !== '0') {
            return <SelectInput source="anomalia.codice" label="Anomalia" onChange={onChange} choices={Anomalie_Approvatore_To_DaEsaminare} validate={required('tim.devices.mandatory')} />
        }
        else if (permissions === "approvatore" && new_status === '9') {
            if (record.status.codice === '1') {
                return <SelectInput source="anomalia.codice" label="Anomalia" onChange={onChange} choices={Anomalie_Approvatore_Attribuito_To_Chiuso} validate={required('tim.devices.mandatory')} />
            }
            else if (record.status.codice === '6') {
                return <SelectInput source="anomalia.codice" label="Anomalia" onChange={onChange} choices={Anomalie_Approvatore_Attribuito_MOS_To_Chiuso} validate={required('tim.devices.mandatory')} />
            }
            else if (record.status.codice === '0') {
                return <SelectInput source="anomalia.codice" label="Anomalia" onChange={onChange} choices={Anomalie_Approvatore_DaEsaminare_To_Chiuso} validate={required('tim.devices.mandatory')} />
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }

    const canEditCodTerrSap = () => {
        if (permissions === 'approvatore' && new_status === '1') {
            // return <CodTerrSapListApprovatore onChange={onChange} />
            return true;
        } else {
            return false;
        }
    }

    const NumConsegna = () => {
        const record = useRecordContext();

        if (!record) return null;

        if (record) {
            if (permissions === 'approvatore' && new_status === '1' && new_cod_terr_sap && new_cod_terr_sap !== record.cod_terr_sap) {
                return <NumberInput source="num_consegna" onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()} onChange={onChange} validate={validateNumConsegna} />;
            }
            else if (new_status === '9') {
                if (['26','29'].includes(new_anomalia))
                    return <NumberInput source="num_consegna" onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()} onChange={onChange} validate={requiredNumConsegna} />;
                else 
                    return <NumberInput source="num_consegna" onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()} onChange={onChange} validate={validateNumConsegna} />;
            }
            else {
                return <TextInput source="num_consegna" sx={{ 'pointer-events': 'none' }}/>
            }
        }


    }

    const CodTerrSapListApprovatore = () => {
        var user_cod_terr_sap = localStorage.getItem('cod_terr_sap');
        var res = [];
        if (user_cod_terr_sap) {
            var x = JSON.parse(user_cod_terr_sap);
            x.forEach(function (c) {
                res.push({ id: c, name: c });
            })
        }
        return <SelectInput source="cod_terr_sap" label="cod_terr_sap" choices={res} onChange={onChange} validate={required('tim.devices.mandatory')} />;
    }

    const Aside = () => {
        const record = useRecordContext();
        if (record) {
            return (
                <Box sx={{ width: '500px', ml: '1em' }}>
                    <Card sx={{ padding: '1em' }}>
                        <Typography variant="h6" sx={{ marginBottom: '1em' }}>Dati di dettaglio</Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.serial_number_tim')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.serial_number_tim}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.serial_number_forn')}
                                </Typography>
                            </Grid><Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.serial_number_forn}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.mac_address')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.mac_address}
                                </Typography>
                            </ Grid>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.workrequestid')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.workrequestid}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.impianto')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.impianto}
                                </Typography>
                            </Grid>

                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.impianto_regman')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.impianto_regman}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.status_regman.descrizione')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.status_regman && (record.status_regman.descrizione)}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.serial_number_cpe')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.serial_number_cpe}
                                </Typography>
                            </Grid>

                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.codice_impresa_name')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.codice_impresa_name}
                                </Typography>
                            </Grid>
                            {!canEditCodTerrSap() && (<>
                                <Grid item xs={6}>
                                    <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                        {translate('resources.devices.fields.cod_terr_sap')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2"  >
                                        {record.cod_terr_sap}
                                    </Typography>
                                </Grid>
                            </>)}
                            {(permissions !== 'approvatore' && !['9', '1'].includes(new_status)) && (<>
                                <Grid item xs={6}>
                                    <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                        {translate('resources.devices.fields.num_consegna')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2"  >
                                        {record.num_consegna}
                                    </Typography>
                                </Grid>
                            </>)}
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.cod_stato_uso.codice')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.cod_stato_uso && (record.cod_stato_uso.descrizione)}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.reverse.descrizione')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.reverse && (record.reverse.descrizione)}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.causale.descrizione')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.causale && (record.causale.descrizione)}
                                </Typography>
                            </Grid>
                            {!(['0', '9'].includes(new_status)) && (<>
                                <Grid item xs={6}>
                                    <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                        {translate('resources.devices.fields.note')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2"  >
                                        {record.note}
                                    </Typography>
                                </Grid>
                            </>)}
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.causale_addebito.codice')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.causale_addebito && (record.causale_addebito.codice)}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.note_addebito')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.note_addebito}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Card>
                </Box>
            );
        }
        else {
            return (
                <div style={{ width: 200, margin: '1em' }}>
                    <Typography variant="h6">Device details</Typography>
                </div>
            );
        }
    };

    return (
        <Edit title={<DeviceTitle />} aside={<Aside />} >
            <SimpleForm toolbar={<DeviceToolbar />} >
                <Status />
                <Anomalia />
                {canEditCodTerrSap() && <CodTerrSapListApprovatore onChange={onChange} />}
                <NumConsegna />
                {(['0', '9'].includes(new_status)) && <TextInput source="note" rowsMax={8} multiline maxWidth="500" validate={validateNote} />}
            </SimpleForm>
        </Edit>
    );
}

export default DeviceDaEsaminareEdit;